export default __webpack_public_path__ + "static/media/logo.429664dc.png";